<template>
  <div class="car-search-bar">
    <input
      class=""
      type="text"
      :placeholder="placeholderValue"
      @keyup="$emit('search', searchText)"
      v-model="searchText"
    />
    <div class="car-search-icon" @click="clearSearchText">
      <icon-search view-box="0 0 16 16" height="18" width="18" icon-color="#1E1D1D" v-if="searchText.length === 0" />
      <icon-close height="18" width="18" v-if="searchText.length > 0" />
    </div>
  </div>
</template>

<script>
import IconSearch from '@/components/icons/IconSearch';
import IconClose from '@/components/icons/IconClose';
export default {
  name: 'SearchBar',
  data: () => {
    return {
      searchText: ''
    }
  },
  props: [
    'placeholderValue',
    'search',
    'isServiceSearch'
  ],
  methods: {
    clearSearchText: function() {
      if (this.searchText.length > 0) {
        this.searchText = '';
        this.$emit('search', this.searchText)
      }
    }
  },
  components: {
    IconClose,
    IconSearch
  }
};
</script>
